<script>
import { mapActions, mapState } from 'vuex';

import LogoHeader from '../../components/onboarding/logo-header.vue';

export default {
  name: 'MatchFrequency',
  components: {
    LogoHeader,
  },
  data() {
    return {
      frequency: null,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.onboarding.isUpdatingOnboarding,
      showOnboarding: (state) => state.login.showOnboarding,
    }),
  },
  watch: {
    showOnboarding(newValue) {
      if (!newValue) {
        this.$router.replace({ name: '/' });
      }
    },
  },
  methods: {
    ...mapActions(['setFormValue', 'updateOnboardingStep']),
    async handleContinue() {
      const nextPage = 'roulette-name';
      const response = await this.updateOnboardingStep(nextPage);
      if (!response) {
        // eslint-disable-next-line
        console.error('Error saving data. Please try again.');
        return;
      }
      this.setFormValue({ field: 'frequency', value: this.frequency });
      this.$router.push({ name: nextPage });
    },
  },
};
</script>

<template>
  <div id="main-container" class="container-fluid">
    <div class="row inner-container">
      <div class="col-6 panel">
        <logo-header />
        <div class="row">
          <div class="my-5 text-center">
            <h3 class="my-4">How often do you want to match team members?</h3>
            <h5 class="text-muted my-5">
              You can change this later and nothing goes live until you activate
            </h5>
            <b-form-select
              v-model="frequency"
              size="lg"
              class="mb-4"
              :options="[
                { value: null, text: 'Select frequency' },
                { value: 1, text: 'Weekly' },
                { value: 2, text: 'Biweekly (every 2 weeks)' },
                { value: 4, text: 'Monthly (every 4 weeks)' },
                { value: 8, text: 'Bimonthly (every 8 weeks)' },
              ]"
            ></b-form-select>
            <b-button block variant="primary" size="lg" @click="handleContinue" :disabled="loading"
              >Continue</b-button
            >
            <div class="mt-5">
              <h1 class="used-by-text">Used by 600+ happy teams!</h1>
              <img
                src="@/assets/team-logos.png"
                alt="Remote Teams"
                fluid
                width="100%"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 panel light-blue">
        <b-progress :value="40" class="progress-container" />

        <div class="text-center mt-5">
          <img src="@/assets/onboarding-3.png" alt="Remote Teams" fluid width="100%" class="mt-5" />
        </div>
        <div class="card mt-5">
          <div class="card-body">✅ Track employee engagement with reporting</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#main-container .inner-container {
  min-height: 100vh;
}

.inner-container .panel {
  padding: 70px;
}

.inner-container .light-blue {
  background-color: #f4f7fc;
}

.used-by-text {
  color: #222e3f;
  font-weight: 600;
  line-height: 140%;
  font-size: 34px;
  font-style: italic;
}
</style>
